import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectUserPermissions } from '../userSlice'
import { PermOp } from '.'

export const useCheckPermissions = (...toCheck: PermOp[]) => {
  const { isAdmin, permissions } = useSelector(selectUserPermissions)

  return useMemo(
    () => toCheck.map((permOp) => isAdmin || permissions.includes(permOp)),
    [toCheck, isAdmin, permissions],
  )
}

export const useCheckAdminPermissions = (...toCheck: PermOp[]) => {
  const { permissions } = useSelector(selectUserPermissions)

  return useMemo(
    () => toCheck.map((permOp) => permissions.includes(permOp)),
    [toCheck, permissions],
  )
}
